export class Utilities {
  static stringToNumber(value: string): number {
    return +value
  }
  static asType<T>(value: unknown): T {
    return value as T
  }
}
